import React, { Component } from 'react'
import AdminUserFilterRowContainer from '../../containers/admin/adminUserFilterRow.container'
import AdminUserFormContainer from '../../containers/admin/adminUserForm.container'
import AdminUpdateFormContainer from '../../containers/admin/adminUpdateForm.container'
import AdminExpenseFormContainer from '../../containers/admin/adminExpenseForm.container'
import AdminIRFormContainer from '../../containers/admin/adminIRForm.container'
import ReactPaginate from 'react-paginate'
import FontAwesome from 'react-fontawesome'

import {
  Paper,
  List,
  ListItem,
  ListItemText,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  Divider,
  Snackbar,
  IconButton,
  Collapse,
  Box,
  Button
} from '@material-ui/core'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import { convertNameToState } from '../../utils/invoice.utils'
import { formatDateAndTime } from '../../utils/dashboard.utils'
import { withStyles } from '@material-ui/core/styles'
import { addDynamicForm, deleteDynamicForm } from '../../form'
import { useDispatch } from 'react-redux'
import { MySnackbarContentWrapper } from '../../utils/snackbar.utils'
import InvoicePanel from './adminInvoicePanel.component'
import SalaryPanel from './adminSalaryPanel.component'
import { downloadCustomersReport } from '../../actions'

const styles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  listItem: {
    margin: '0px',
    textAlign: 'center'
  },
  listItemText: {
    fontSize: '15px',
    marginLeft: '10px'
  },
  button: {
    margin: theme.spacing(1)
  },
  tableCell: {
    fontSize: '13px'
  },
  tableCellUser: {
    fontSize: '13px',
    border: 'none'
  },
  tableCellExpandable: {
    fontSize: '13px',
    borderBottom: '1px solid lightgray',
    padding: '0px 0px'
  },
  tableHead: {
    fontSize: '13px',
    fontWeight: 'bold',
    borderBottom: '1px solid gray'
  }
})

class Admin extends Component {
  componentDidMount() {
    this.props.adminGetUpdates()
    this.props.getFieldOfWork()
    this.props.getUserCompanyUpdateInfo()
  }

  render() {
    return <AdminComponent {...this.props} />
  }
}

export default withStyles(styles)(Admin)

const AdminComponent = ({
  changeAdminMenu,
  invoiceSearchRows,
  invoiceSearchPages,
  searchAdminInvoice,
  searchInvoiceSummary,
  selected,
  isToPay,
  isToPayInvoiceId,
  isInvoiceUnclear,
  isLahetetty,
  isReklamoitu,
  isPerinnassa,
  isMuokattu,
  isAdminSent,
  isAdminRejected,
  isAdminHalfPaid,
  isReminderActive,
  removeInvoiceFeeWithReason,
  showRemoveInvoiceFeeDialog,
  cancelRemoveInvoiceFeeDialog,
  feeType,
  invoiceNotes,
  showInvoicePDF,
  updateAdminInvoiceStatusToPerinnassa,
  showReminderInvoicePDF,
  warnInvoiceToPay,
  noPikapalkka,
  updateAdminInvoiceStatus,
  cancelUpdateAdminInvoiceStatus,
  closeDialog,
  userSearchRows,
  userSearchPages,
  userSearchPageChange,
  expandAdminUser,
  expandAdminInvoice,
  expandAdminSalary,
  iRSearchPages,
  irSearchPageChange,
  salarySearchRows,
  salarySearchSummary,
  salarySearchPages,
  searchAdminWages,
  warnSalaryToPay,
  //isToPaySalaryId,
  showSalaryPDF,
  isToLiftSalary,
  cancelUpdateAdminSalaryStatus,
  updateAdminSalaryStatus,
  isSalaryRowSelected,
  confirmSalaryToPay,
  isImportSalary,
  isValidBatch,
  isIRValidBatch,
  isIRCacelReportValidBatch,
  importKassavirtanenSalaries,
  salarySendtoIR,
  cancelSalaryIRReport,
  manualPaySalaries,
  selectedRows,
  showAdminSnackbar,
  showAdminFailSnackbar,
  isUpdateTaxCardSuccess,
  isUpdateTaxCardFailed,
  hideAdminSnackbar,
  showAdminSalPayFailSnackbar,
  salPayFailMessage,
  showAdminSalaryStatusSuccessSnackbar,
  salaryStatusSuccessMessage,
  showExpenseReportSuccessSnackbar,
  showExpenseReportFailedSnackbar,
  expenseReportFailedMessage,
  showPartialPayFailSnackbar,
  partialPayFailMessage,
  releaseSearchRows,
  adminDeleteCompanyUpdates,
  tiedotteetSearchPages,
  tiedotteetSearchPageChange,
  updateAdminInvoiceStatusToRejected,
  updateAdminInvoiceStatusToNew,
  updateAdminInvoiceStatusToLoaned,
  sentInvoiceReminder,
  irSearchRows,
  updateSalaryStatusIR,
  adminSalaryPageSize,
  selectedSalaryRowIndex,
  adminInvoicePageSize,
  classes,
  shouldCloseUserForms,
  shouldCloseInvoiceForms,
  shouldCloseSalaryForms,
  shouldUpdateTable,
  updateAdminTableSuccess,
  fieldOfWork,
  allInvoiceInMonthSearch,
  allSalaryRecords,
  showSsnSnackbar,
  is_group_invoice,
  searchCompanyCustomers
}) => {
  const [selectedMenuItem, setSelectedMenuItem] = React.useState(0)

  const handleChangeAdminMenu = (index) => {
    setSelectedMenuItem(index)
    changeAdminMenu(index)
  }

  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <div className="dashboard-content-header">
            <h1>Hallintapaneeli</h1>
          </div>
        </div>
        <div className="dashboard-content-header">
          <hr />
        </div>
        <div className="row">
          <div className="dashboard-content-header">
            <div className="col-xs-12 col-sm-12 col-lg-12">
              <div className="row">
                {sideMenu(handleChangeAdminMenu, selectedMenuItem, classes)}
              </div>
              <div className="row">
                {selectPanel(
                  classes,
                  selectedMenuItem,
                  invoiceSearchRows,
                  invoiceSearchPages,
                  searchAdminInvoice,
                  searchInvoiceSummary,
                  selected,
                  isToPay,
                  isToPayInvoiceId,
                  isInvoiceUnclear,
                  isLahetetty,
                  isReklamoitu,
                  isPerinnassa,
                  isMuokattu,
                  isAdminSent,
                  isAdminRejected,
                  isAdminHalfPaid,
                  isReminderActive,
                  removeInvoiceFeeWithReason,
                  showRemoveInvoiceFeeDialog,
                  cancelRemoveInvoiceFeeDialog,
                  feeType,
                  invoiceNotes,
                  showInvoicePDF,
                  updateAdminInvoiceStatusToPerinnassa,
                  showReminderInvoicePDF,
                  warnInvoiceToPay,
                  noPikapalkka,
                  updateAdminInvoiceStatus,
                  cancelUpdateAdminInvoiceStatus,
                  closeDialog,
                  userSearchRows,
                  userSearchPages,
                  userSearchPageChange,
                  expandAdminUser,
                  expandAdminInvoice,
                  expandAdminSalary,
                  iRSearchPages,
                  irSearchPageChange,
                  salarySearchRows,
                  salarySearchSummary,
                  salarySearchPages,
                  searchAdminWages,
                  warnSalaryToPay,
                  //isToPaySalaryId,
                  showSalaryPDF,
                  isToLiftSalary,
                  cancelUpdateAdminSalaryStatus,
                  updateAdminSalaryStatus,
                  isSalaryRowSelected,
                  confirmSalaryToPay,
                  isImportSalary,
                  isValidBatch,
                  isIRValidBatch,
                  isIRCacelReportValidBatch,
                  importKassavirtanenSalaries,
                  salarySendtoIR,
                  cancelSalaryIRReport,
                  manualPaySalaries,
                  selectedRows,
                  releaseSearchRows,
                  adminDeleteCompanyUpdates,
                  tiedotteetSearchPages,
                  tiedotteetSearchPageChange,
                  updateAdminInvoiceStatusToRejected,
                  updateAdminInvoiceStatusToNew,
                  updateAdminInvoiceStatusToLoaned,
                  sentInvoiceReminder,
                  irSearchRows,
                  updateSalaryStatusIR,
                  adminSalaryPageSize,
                  selectedSalaryRowIndex,
                  adminInvoicePageSize,
                  shouldCloseUserForms,
                  shouldCloseInvoiceForms,
                  shouldCloseSalaryForms,
                  shouldUpdateTable,
                  updateAdminTableSuccess,
                  handleChangeAdminMenu,
                  fieldOfWork,
                  allInvoiceInMonthSearch,
                  allSalaryRecords,
                  is_group_invoice,
                  searchCompanyCustomers
                )}
              </div>
            </div>
          </div>
        </div>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          open={showAdminSnackbar && isUpdateTaxCardSuccess}
          autoHideDuration={3000}
          onClose={hideAdminSnackbar}
        >
          <MySnackbarContentWrapper
            onClose={hideAdminSnackbar}
            variant="success"
            message="Tiedot päivitetty"
          />
        </Snackbar>
        {/* KAS-361 SSN duplicated */}
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          open={showSsnSnackbar}
          autoHideDuration={3000}
          onClose={hideAdminSnackbar}
        >
          <MySnackbarContentWrapper
            onClose={hideAdminSnackbar}
            variant="error"
            message="Tällä henkilötunnuksella on jo rekisteröidytty palveluun."
          />
        </Snackbar>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          open={showAdminFailSnackbar || isUpdateTaxCardFailed}
          autoHideDuration={4000}
          onClose={hideAdminSnackbar}
        >
          <MySnackbarContentWrapper
            onClose={hideAdminSnackbar}
            variant="error"
            message="Päivitys epäonnistui"
          />
        </Snackbar>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          open={showAdminSalPayFailSnackbar}
          autoHideDuration={4000}
          onClose={hideAdminSnackbar}
        >
          <MySnackbarContentWrapper
            onClose={hideAdminSnackbar}
            variant="error"
            message={salPayFailMessage}
          />
        </Snackbar>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          open={showAdminSalaryStatusSuccessSnackbar}
          autoHideDuration={3000}
          onClose={hideAdminSnackbar}
        >
          <MySnackbarContentWrapper
            onClose={hideAdminSnackbar}
            variant="success"
            message={salaryStatusSuccessMessage}
          />
        </Snackbar>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          open={showExpenseReportSuccessSnackbar}
          autoHideDuration={3000}
          onClose={hideAdminSnackbar}
        >
          <MySnackbarContentWrapper
            onClose={hideAdminSnackbar}
            variant="success"
            message="Kuluraportit tallennettu ja lähetetty!"
          />
        </Snackbar>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          open={showExpenseReportFailedSnackbar}
          autoHideDuration={4000}
          onClose={hideAdminSnackbar}
        >
          <MySnackbarContentWrapper
            onClose={hideAdminSnackbar}
            variant="error"
            message={expenseReportFailedMessage}
          />
        </Snackbar>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          open={showPartialPayFailSnackbar}
          autoHideDuration={4000}
          onClose={hideAdminSnackbar}
        >
          <MySnackbarContentWrapper
            onClose={hideAdminSnackbar}
            variant="error"
            message={partialPayFailMessage}
          />
        </Snackbar>
      </div>
    </div>
  )
}

const selectPanel = (
  classes,
  selectedMenuItem,
  invoiceSearchRows,
  invoiceSearchPages,
  searchAdminInvoice,
  searchInvoiceSummary,
  selected,
  isToPay,
  isToPayInvoiceId,
  isInvoiceUnclear,
  isLahetetty,
  isReklamoitu,
  isPerinnassa,
  isMuokattu,
  isAdminSent,
  isAdminRejected,
  isAdminHalfPaid,
  isReminderActive,
  removeInvoiceFeeWithReason,
  showRemoveInvoiceFeeDialog,
  cancelRemoveInvoiceFeeDialog,
  feeType,
  invoiceNotes,
  showInvoicePDF,
  updateAdminInvoiceStatusToPerinnassa,
  showReminderInvoicePDF,
  warnInvoiceToPay,
  noPikapalkka,
  updateAdminInvoiceStatus,
  cancelUpdateAdminInvoiceStatus,
  closeDialog,
  userSearchRows,
  userSearchPages,
  userSearchPageChange,
  expandAdminUser,
  expandAdminInvoice,
  expandAdminSalary,
  iRSearchPages,
  irSearchPageChange,
  salarySearchRows,
  salarySearchSummary,
  salarySearchPages,
  searchAdminWages,
  warnSalaryToPay,
  //isToPaySalaryId,
  showSalaryPDF,
  isToLiftSalary,
  cancelUpdateAdminSalaryStatus,
  updateAdminSalaryStatus,
  isSalaryRowSelected,
  confirmSalaryToPay,
  isImportSalary,
  isValidBatch,
  isIRValidBatch,
  isIRCacelReportValidBatch,
  importKassavirtanenSalaries,
  salarySendtoIR,
  cancelSalaryIRReport,
  manualPaySalaries,
  selectedRows,
  releaseSearchRows,
  adminDeleteCompanyUpdates,
  tiedotteetSearchPages,
  tiedotteetSearchPageChange,
  updateAdminInvoiceStatusToRejected,
  updateAdminInvoiceStatusToNew,
  updateAdminInvoiceStatusToLoaned,
  sentInvoiceReminder,
  irSearchRows,
  updateSalaryStatusIR,
  adminSalaryPageSize,
  selectedSalaryRowIndex,
  adminInvoicePageSize,
  shouldCloseUserForms,
  shouldCloseInvoiceForms,
  shouldCloseSalaryForms,
  shouldUpdateTable,
  updateAdminTableSuccess,
  handleChangeAdminMenu,
  fieldOfWork,
  allInvoiceInMonthSearch,
  allSalaryRecords,
  is_group_invoice,
  searchCompanyCustomers
) => {
  const dispatch = useDispatch()

  function handleDownloadCustomersReport() {
    dispatch(downloadCustomersReport(userSearchRows))
  }

  switch (selectedMenuItem) {
    case 0:
      return customerPanel(
        classes,
        userSearchRows,
        selected,
        userSearchPages,
        userSearchPageChange,
        expandAdminUser,
        shouldCloseUserForms,
        handleChangeAdminMenu,
        fieldOfWork,
        handleDownloadCustomersReport
      )
    case 1:
      return (
        <InvoicePanel
          classes={classes}
          invoiceSearchRows={invoiceSearchRows}
          invoiceSearchPages={invoiceSearchPages}
          searchAdminInvoice={searchAdminInvoice}
          searchInvoiceSummary={searchInvoiceSummary}
          selected={selected}
          isToPay={isToPay}
          isToPayInvoiceId={isToPayInvoiceId}
          isInvoiceUnclear={isInvoiceUnclear}
          isLahetetty={isLahetetty}
          isReklamoitu={isReklamoitu}
          isPerinnassa={isPerinnassa}
          isMuokattu={isMuokattu}
          isAdminSent={isAdminSent}
          isAdminRejected={isAdminRejected}
          isAdminHalfPaid={isAdminHalfPaid}
          isReminderActive={isReminderActive}
          removeInvoiceFeeWithReason={removeInvoiceFeeWithReason}
          showRemoveInvoiceFeeDialog={showRemoveInvoiceFeeDialog}
          cancelRemoveInvoiceFeeDialog={cancelRemoveInvoiceFeeDialog}
          feeType={feeType}
          invoiceNotes={invoiceNotes}
          shouldCloseInvoiceForms={shouldCloseInvoiceForms}
          showInvoicePDF={showInvoicePDF}
          updateAdminInvoiceStatusToPerinnassa={
            updateAdminInvoiceStatusToPerinnassa
          }
          expandAdminInvoice={expandAdminInvoice}
          showReminderInvoicePDF={showReminderInvoicePDF}
          warnInvoiceToPay={warnInvoiceToPay}
          noPikapalkka={noPikapalkka}
          updateAdminInvoiceStatus={updateAdminInvoiceStatus}
          cancelUpdateAdminInvoiceStatus={cancelUpdateAdminInvoiceStatus}
          closeDialog={closeDialog}
          updateAdminInvoiceStatusToRejected={
            updateAdminInvoiceStatusToRejected
          }
          updateAdminInvoiceStatusToNew={updateAdminInvoiceStatusToNew}
          updateAdminInvoiceStatusToLoaned={updateAdminInvoiceStatusToLoaned}
          sentInvoiceReminder={sentInvoiceReminder}
          adminInvoicePageSize={adminInvoicePageSize}
          shouldUpdateTable={shouldUpdateTable}
          updateAdminTableSuccess={updateAdminTableSuccess}
          allInvoiceInMonthSearch={allInvoiceInMonthSearch}
          is_group_invoice={is_group_invoice}
        />
      )
    case 2:
      return (
        <SalaryPanel
          salarySearchRows={salarySearchRows}
          salarySearchSummary={salarySearchSummary}
          selected={selected}
          salarySearchPages={salarySearchPages}
          searchAdminWages={searchAdminWages}
          warnSalaryToPay={warnSalaryToPay}
          //isToPaySalaryId={}
          showSalaryPDF={showSalaryPDF}
          isToLiftSalary={isToLiftSalary}
          cancelUpdateAdminSalaryStatus={cancelUpdateAdminSalaryStatus}
          updateAdminSalaryStatus={updateAdminSalaryStatus}
          isSalaryRowSelected={isSalaryRowSelected}
          confirmSalaryToPay={confirmSalaryToPay}
          isImportSalary={isImportSalary}
          isValidBatch={isValidBatch}
          isIRValidBatch={isIRValidBatch}
          isIRCacelReportValidBatch={isIRCacelReportValidBatch}
          importKassavirtanenSalaries={importKassavirtanenSalaries}
          salarySendtoIR={salarySendtoIR}
          cancelSalaryIRReport={cancelSalaryIRReport}
          manualPaySalaries={manualPaySalaries}
          selectedRows={selectedRows}
          updateSalaryStatusIR={updateSalaryStatusIR}
          adminSalaryPageSize={adminSalaryPageSize}
          selectedSalaryRowIndex={selectedSalaryRowIndex}
          shouldUpdateTable={shouldUpdateTable}
          updateAdminTableSuccess={updateAdminTableSuccess}
          allSalaryRecords={allSalaryRecords}
          expandAdminSalary={expandAdminSalary}
          shouldCloseSalaryForms={shouldCloseSalaryForms}
          handleChangeAdminMenu={handleChangeAdminMenu}
          searchCompanyCustomers={searchCompanyCustomers}
        />
      )
    case 3:
      return kulutPanel()
    case 4:
      return tiedotteetPanel(
        classes,
        releaseSearchRows,
        selected,
        adminDeleteCompanyUpdates,
        tiedotteetSearchPages,
        tiedotteetSearchPageChange
      )
    case 5:
      return irPanel(
        classes,
        selected,
        iRSearchPages,
        irSearchPageChange,
        irSearchRows
      )
  }
}

const sideMenu = (handleChangeAdminMenu, selectedMenuItem, classes) => (
  <div
    style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}
  >
    <Paper className="row">
      <List
        style={{
          display: 'flex',
          flexDirection: 'row',
          padding: '8px 8px',
          margin: '0px'
        }}
      >
        <ListItem
          button
          selected={selectedMenuItem === 0}
          onClick={() => handleChangeAdminMenu(0)}
          className={classes.listItem}
        >
          <ListItemText
            primary="Asiakkaat"
            classes={{ primary: classes.listItemText }}
          />
        </ListItem>
        <ListItem
          button
          selected={selectedMenuItem === 1}
          onClick={() => handleChangeAdminMenu(1)}
          className={classes.listItem}
        >
          <ListItemText
            primary="Laskut"
            classes={{ primary: classes.listItemText }}
          />
        </ListItem>
        <ListItem
          button
          selected={selectedMenuItem === 2}
          onClick={() => handleChangeAdminMenu(2)}
          className={classes.listItem}
        >
          <ListItemText
            primary="Palkat"
            classes={{ primary: classes.listItemText }}
          />
        </ListItem>
        <ListItem
          button
          selected={selectedMenuItem === 3}
          onClick={() => handleChangeAdminMenu(3)}
          className={classes.listItem}
        >
          <ListItemText
            primary="Kulut"
            classes={{ primary: classes.listItemText }}
          />
        </ListItem>
        <ListItem
          button
          selected={selectedMenuItem === 4}
          onClick={() => handleChangeAdminMenu(4)}
          className={classes.listItem}
        >
          <ListItemText
            primary="Tiedotteet"
            classes={{ primary: classes.listItemText }}
          />
        </ListItem>
        <ListItem
          button
          selected={selectedMenuItem === 5}
          onClick={() => handleChangeAdminMenu(5)}
        >
          <ListItemText
            primary="Tulorekisteri"
            classes={{ primary: classes.listItemText }}
          />
        </ListItem>
      </List>
    </Paper>
  </div>
)

const customerPanel = (
  classes,
  userSearchRows,
  selected,
  userSearchPages,
  userSearchPageChange,
  expandAdminUser,
  shouldCloseUserForms,
  handleChangeAdminMenu,
  fieldOfWork,
  handleDownloadCustomersReport
) => (
  <div className="col-xs-12 col-sm-12 col-lg-12">
    <div className="panel panel-default">
      <div className="panel-body">
        <AdminUserFilterRowContainer />
      </div>
      <hr style={{ marginTop: '0px' }} />
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHead} style={{ width: '12%' }}>
              Etunimi
            </TableCell>
            <TableCell className={classes.tableHead} style={{ width: '15%' }}>
              Sukunimi
            </TableCell>
            <TableCell className={classes.tableHead} style={{ width: '30%' }}>
              Sähköposti
            </TableCell>
            <TableCell className={classes.tableHead} style={{ width: '20%' }}>
              Rekisteröitymispäivä
            </TableCell>
            <TableCell className={classes.tableHead} style={{ width: '20%' }}>
              Yhteensä Laskun Summa (€)
            </TableCell>
            <TableCell
              className={classes.tableHead}
              style={{ width: '3%' }}
            ></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {createUserRows(
            classes,
            userSearchRows,
            selected,
            expandAdminUser,
            shouldCloseUserForms,
            handleChangeAdminMenu,
            fieldOfWork
          )}
        </TableBody>
      </Table>
      <Divider />
      <div className="panel-body">
        <ReactPaginate
          previousLabel={<i className="fa fa-chevron-left" />}
          nextLabel={<i className="fa fa-chevron-right" />}
          breakLabel={'...'}
          breakClassName={'break-me'}
          pageCount={userSearchPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={userSearchPageChange}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
          forcePage={userSearchPages === 0 ? undefined : selected}
        />
        <Box pt={2}>
          <Button
            variant="contained"
            onClick={handleDownloadCustomersReport}
            disabled={userSearchRows.length === 0}
          >
            Lataa asiakasraportti
          </Button>
        </Box>
      </div>
    </div>
  </div>
)

const kulutPanel = () => (
  <div className="col-xs-12 col-sm-12 col-lg-12">
    <div className="panel panel-default">
      <div className="panel-heading">
        <h3 className="panel-title">Yrityksen kulut</h3>
      </div>
      <div className="panel-body">
        <AdminExpenseFormContainer />
      </div>
      <div className="panel-body"></div>
    </div>
  </div>
)

const irPanel = (
  classes,
  selected,
  iRSearchPages,
  irSearchPageChange,
  irSearchRows
) => (
  <div className="col-xs-12 col-sm-12 col-lg-12">
    <div className="panel panel-default">
      <div className="panel-heading">
        <h3 className="panel-title">IR Info</h3>
      </div>
      <div className="panel-body">
        <AdminIRFormContainer />
      </div>
      <hr style={{ marginTop: '0px' }} />
      <div className="panel-body">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                className={classes.tableHead}
                style={{ padding: '8px' }}
              >
                Käyttäjänimi
              </TableCell>
              <TableCell
                className={classes.tableHead}
                style={{ padding: '8px' }}
              >
                Palkatunnus
              </TableCell>
              <TableCell
                className={classes.tableHead}
                style={{ padding: '8px' }}
              >
                Omistajan viitenumero
              </TableCell>
              <TableCell
                className={classes.tableHead}
                style={{ padding: '8px' }}
              >
                TR viite
              </TableCell>
              <TableCell
                className={classes.tableHead}
                style={{ padding: '8px' }}
              >
                TR raportin viite
              </TableCell>
              <TableCell
                className={classes.tableHead}
                style={{ padding: '8px' }}
              >
                Tila
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{createIRRow(classes, selected, irSearchRows)}</TableBody>
        </Table>
        <Divider />
        <ReactPaginate
          previousLabel={<i className="fa fa-chevron-left" />}
          nextLabel={<i className="fa fa-chevron-right" />}
          breakLabel={'...'}
          breakClassName={'break-me'}
          pageCount={iRSearchPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={irSearchPageChange}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
          forcePage={iRSearchPages === 0 ? undefined : selected}
        />
      </div>
      <div className="panel-body"></div>
    </div>
  </div>
)

const tiedotteetPanel = (
  classes,
  releaseSearchRows,
  selected,
  adminDeleteCompanyUpdates,
  tiedotteetSearchPages,
  tiedotteetSearchPageChange
) => (
  <div className="col-xs-12 col-sm-12 col-lg-12">
    <div className="panel panel-default">
      <div className="panel-heading">
        <h3 className="panel-title">Yrityspäivitykset</h3>
      </div>
      <div className="panel-body">
        <AdminUpdateFormContainer />
      </div>
      <hr style={{ marginTop: '0px' }} />
      <div className="panel-body">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableHead}>Julkaisupäivä</TableCell>
              <TableCell className={classes.tableHead}>Julkaisu</TableCell>
              <TableCell className={classes.tableHead}>Toiminnot</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {createReleaseRow(
              classes,
              releaseSearchRows,
              selected,
              adminDeleteCompanyUpdates
            )}
          </TableBody>
        </Table>
        <Divider />
        <ReactPaginate
          previousLabel={<i className="fa fa-chevron-left" />}
          nextLabel={<i className="fa fa-chevron-right" />}
          breakLabel={'...'}
          breakClassName={'break-me'}
          pageCount={tiedotteetSearchPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={tiedotteetSearchPageChange}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
        />
      </div>
    </div>
  </div>
)

const createReleaseRow = (
  classes,
  releases,
  selected,
  adminDeleteCompanyUpdates
) =>
  releases.slice(selected * 10, selected * 10 + 10).map((el) => (
    <TableRow key={el.id}>
      <TableCell className={classes.tableCell}>
        {formatDateAndTime(el.created)}
      </TableCell>
      <TableCell
        className={classes.tableCell}
        style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
      >
        <span>{el.newsupdate}</span>
      </TableCell>
      <TableCell className={classes.tableCell}>
        <div style={{ display: 'flex' }}>
          <p
            style={{ marginLeft: '10px', marginTop: '6px' }}
            onClick={() => {
              adminDeleteCompanyUpdates(el.id)
            }}
          >
            <FontAwesome
              name="window-close"
              style={{
                color: 'red'
              }}
            />
          </p>
        </div>
      </TableCell>
    </TableRow>
  ))

const createIRRow = (classes, selected, irResults) =>
  irResults.slice(selected * 10, selected * 10 + 10).map((el) => (
    <TableRow key={el.salary_id + el.delivery_id}>
      {
        <TableCell
          className={classes.tableCell}
          style={{
            padding: '8px',
            whiteSpace: 'normal',
            wordWrap: 'break-word'
          }}
        >
          {el.firstname}
        </TableCell>
      }
      <TableCell
        className={classes.tableCell}
        style={{
          padding: '8px',
          whiteSpace: 'normal',
          wordWrap: 'break-word'
        }}
      >
        {el.salary_id}
      </TableCell>
      <TableCell
        className={classes.tableCell}
        style={{
          padding: '8px',
          whiteSpace: 'normal',
          wordWrap: 'break-word'
        }}
      >
        {el.delivery_id}
      </TableCell>
      <TableCell
        className={classes.tableCell}
        style={{
          padding: '8px',
          whiteSpace: 'normal',
          wordWrap: 'break-word'
        }}
      >
        {el.ir_delivery_id}
      </TableCell>
      <TableCell
        className={classes.tableCell}
        style={{
          padding: '8px',
          whiteSpace: 'normal',
          wordWrap: 'break-word'
        }}
      >
        {el.ir_item_id}
      </TableCell>
      <TableCell
        className={classes.tableCell}
        style={{
          padding: '8px',
          whiteSpace: 'normal'
        }}
      >
        {convertNameToState(el.report_status)}
      </TableCell>
    </TableRow>
  ))

const createUserRows = (
  classes,
  users,
  selected,
  expandAdminUser,
  shouldCloseUserForms,
  handleChangeAdminMenu,
  fieldOfWork
) => {
  return users
    .slice(selected * 10, selected * 10 + 10)
    .map((el, index) => (
      <UserRow
        classes={classes}
        user={el}
        getDetails={expandAdminUser}
        index={index}
        key={index}
        pageIndex={selected}
        shouldCloseUserForms={shouldCloseUserForms}
        handleChangeAdminMenu={handleChangeAdminMenu}
        fieldOfWork={fieldOfWork}
      />
    ))
}

const UserRow = ({
  classes,
  user,
  getDetails,
  index,
  shouldCloseUserForms,
  pageIndex,
  handleChangeAdminMenu,
  fieldOfWork
}) => {
  const dispatch = useDispatch()
  const [open, setOpen] = React.useState(false)

  function handleExpand(e) {
    if (!open) {
      getDetails(e, user.uuid)
      dispatch(addDynamicForm('adminForm' + index))
    } else {
      dispatch(deleteDynamicForm('adminForm' + index))
    }
    setOpen(!open)
  }

  React.useEffect(() => {
    if (shouldCloseUserForms && open) {
      setOpen(false)
      dispatch(deleteDynamicForm('adminForm' + index))
    }
  }, [shouldCloseUserForms, setOpen])

  React.useEffect(() => {
    if (open) {
      setOpen(false)
      dispatch(deleteDynamicForm('adminForm' + index))
    }
  }, [pageIndex, setOpen])

  return (
    <>
      <TableRow key={user.uuid}>
        <TableCell className={classes.tableCellUser}>
          {user.firstname}
        </TableCell>
        <TableCell className={classes.tableCellUser}>{user.lastname}</TableCell>
        <TableCell className={classes.tableCellUser}>{user.email}</TableCell>
        <TableCell className={classes.tableCellUser}>{user.created}</TableCell>
        <TableCell className={classes.tableCellUser}>
          {user.invoicedUserInvoices}
        </TableCell>
        <TableCell className={classes.tableCellUser}>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={handleExpand}
          >
            {open ? (
              <KeyboardArrowUpIcon fontSize="large" />
            ) : (
              <KeyboardArrowDownIcon fontSize="large" />
            )}
          </IconButton>
        </TableCell>
      </TableRow>
      {
        <TableRow style={{ height: '0px' }}>
          <TableCell className={classes.tableCellExpandable} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <div style={{ padding: '20px' }}>
                {user.expanded &&
                  expandedUserFormData(
                    user,
                    user.expandData,
                    user.taxCard,
                    user.uuid,
                    index,
                    handleChangeAdminMenu,
                    fieldOfWork
                  )}{' '}
              </div>
            </Collapse>
          </TableCell>
        </TableRow>
      }
    </>
  )
}

const expandedUserFormData = (
  user,
  expandData,
  taxCard,
  uuid,
  index,
  handleChangeAdminMenu,
  fieldOfWork
) => (
  <AdminUserFormContainer
    form={`AdminUserForm_${expandData.email.replace('.', '')}`}
    initialValues={expandData}
    uuid={uuid}
    email={expandData.email}
    index={index}
    handleChangeAdminMenu={handleChangeAdminMenu}
    fieldOfWork={fieldOfWork}
    taxCard={taxCard}
    user={user}
  />
)
